const jQuery = window.jQuery

export default jQuery
export { jQuery }
